'use strict';
var parent = require('../../stable/symbol/to-string-tag');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/symbol/to-string-tag.js
// module id = 554
// module chunks = 13